import { Injectable } from "@angular/core";
import { AvisInitialTypeLight } from "../../models/AvisInitialTypeLight";
import { FormMapaATControlNames } from '../../formMapaATControlNames';

@Injectable({
    providedIn: 'root'
})
export class AvisInitialService {

    constructor() {
    }

    public getAvisInitial(controls): AvisInitialTypeLight {

        const avisInitial = new AvisInitialTypeLight();
        avisInitial.idWeb = controls.get('_SepSep_AttributionFromMAPA_SepSep_AvisInitialType_SepAtt_idWeb')
        avisInitial.datePublication = controls.get(FormMapaATControlNames.datePublication)
            + controls.get(FormMapaATControlNames.datePublication + '_timestamp')

        return avisInitial;
    }
}
